import React, { useState, useRef, useEffect } from "react";
import { Alert, Button, themes, Tooltip } from '@digitools/honest-react';
import { RIA_TEXT } from "../constants/RiaConstants";
import useTranslate from "src/hooks/useTranslate";
import { setCorrespondencePreference } from "../api/RiaApi";
import useAuthentication from "src/hooks/useAuthentication";
const CorrespondenceAlert = () => {
    const { authHeader } = useAuthentication();
    const { t } = useTranslate();
    const [togglePrompt, setTogglePrompt] = useState(false);
    const alertRef = useRef(null);
    useEffect(() => {
        if (togglePrompt && alertRef.current) {
            const closeButton = alertRef.current.querySelector('button[aria-label], button[data-testid="close"], button.close, button[class*="close"]');
            if (closeButton) {
                closeButton.focus();
            }
        }
    }, [togglePrompt]);
    const ToolTipText = (<>
            <strong>{t(RIA_TEXT.correspondenceTitle)}</strong>
            <p>
                <span>{t(RIA_TEXT.correspondenceToolTip)}</span>
            </p>
        </>);
    const toggleOnClick = () => {
        if (!togglePrompt) {
            const correspondencePreference = {
                emailCorrespondence: true,
                suppressPopup: false,
            };
            setCorrespondencePreference(correspondencePreference, authHeader());
            setTogglePrompt(true);
        }
    };
    return (<div ref={alertRef}>
        <Alert data-testid={'correspondence-preference'} type={'info'} aria-labelledby='correspondence-preference' alignIcon="flex-start" closeable={true} style={{ marginBottom: '0.5rem' }}>
            {togglePrompt ?
            <div style={{ marginRight: '0.25rem', marginLeft: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    {t(RIA_TEXT.correspondenceThankYou)}
                </div>
            :
                <div>
                    <div style={{ marginRight: '0.25rem', marginLeft: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <span style={{ marginLeft: 'auto', marginRight: '0.25rem', marginTop: 'auto', marginBottom: 'auto' }}>{t(RIA_TEXT.correspondencePrompt)}</span>
                            <div className='d-none d-md-flex'>
                                <div style={{ marginTop: 'auto', marginRight: '0.25rem', marginBottom: 'auto' }}>
                                    <Tooltip iconName={'question'} iconColor={'secondary'} label={ToolTipText} position={'bottom'} theme={themes.rebrand} style={{ pointerEvents: 'auto', width: 'auto', minWidth: '20rem' }}/>
                                </div>
                                <Button data-testid={"toggle-button"} buttonType={'primary'} size={"small"} onClick={toggleOnClick} style={{ marginLeft: '10rem', maxHeight: '50px', minWidth: '10rem' }}>Go Paperless</Button>
                            </div>
                    </div>
                    <div className='d-flex d-md-none' style={{ textAlign: 'center', flexDirection: 'column' }}>
                        <Tooltip iconName={'question'} iconColor={'secondary'} label={ToolTipText} position={'bottom'} theme={themes.rebrand} style={{ pointerEvents: 'auto', width: 'auto', minWidth: '20rem' }}/>
                        <Button data-testid={"toggle-button"} buttonType={'primary'} size={"small"} onClick={toggleOnClick} style={{ maxHeight: '50px', width: "100%", marginTop: '1rem' }}>Go Paperless</Button>
                    </div>
                </div>}
        </Alert>
        </div>);
};
export default CorrespondenceAlert;
